<template>
    <el-card class="box-card">
        <!-- 表单只有一个文本框的时候，按回车会自动submit表单，需要禁用sunmit -->
        <el-form
            ref="searchform"
            :inline="true"
            :model="form"
            @submit.native.prevent
            size="medium"
        >
            <el-form-item label="类别名称" prop="name">
                <el-input
                    v-model="form.name"
                    placeholder="类别名称搜索"
                    class="namec"
                    @keyup.enter.native="search()"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item label="类型搜索" prop="with_type">
                <el-select
                    v-model="form.with_type"
                    placeholder="选择类型"
                    class="with_typec"
                    clearable
                >
                    <el-option
                        v-for="(value,index) in this.$store.state.office_supplies_type"
                        :key="value"
                        :label="value"
                        :value="index"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" plain @click="search">搜索</el-button>
                <el-button type="warning" plain @click="resetbtn('searchform')"
                    >重置</el-button
                >
            </el-form-item>
            <el-button
                v-if="$_has(add_auth)"
                type="success"
                plain
                round
                @click="addTeam"
                class="temp_add"
                size="medium"
                >添加办公用品类别</el-button
            >
        </el-form>
    </el-card>
</template>

<script>
export default {
    name: 'SuppliesCategorySearchBarComponent',
    data() {
        return {
            fdialogFormVisible: false,
            form: {
                name: '',
                with_type: '',
                page: 1,
            },
        }
    },
    computed: {},
    methods: {
        search() {
            this.$emit('search', this.form)
        },
        resetbtn(f) {
            this.$refs[f].resetFields()
        },
        addTeam() {
            this.$emit('addTeam')
        },
    },
    filters: {},
    props: {
        add_auth: String
    },
    created() {},
    destoryed() {},
    mounted() {},
    updated() {},
    components: {},
    watch: {},
}
</script>

<style>
.temp_add {
    float: right;
    margin-bottom: 10px;
}
</style>